<template>
    <div>
        <div class="bg-light rounded border p-50 d-flex align-items-center justify-content-between" v-on:click="show = !show">
            <div>Toplam {{(row.Levies || []).length}} İcra</div>
            <div class="d-flex align-items-center">
                <feather-icon size="16" class="text-secondary mr-50" :icon="show ? 'ChevronDownIcon' : 'ChevronRightIcon'"></feather-icon>
                <button class="btn btn-sm btn-success" v-on:click.stop="uploadExcel()">Excel Yükle</button>
            </div>
        </div>
        <b-collapse v-model="show">
            <table class="table table-sm table-bordered my-50">
                    <tbody>
                        <tr>
                            <td class="w-50 font-weight-bolder">Toplam Ödenen Borç</td>
                            <td>{{row.PaidDebt || '-'}} TL</td>
                        </tr>
                        <tr>
                            <td class="w-50 font-weight-bolder">Toplam Kalan Borç</td>
                            <td>{{row.RemainingDebt || '-'}} TL</td>
                        </tr>
                        <tr>
                            <td class="w-50 font-weight-bolder">Toplam Borç</td>
                            <td>{{row.TotalDebt || '-'}} TL</td>
                        </tr>
                    </tbody>
                </table>
            <v-table    ref="table"
                        class="mt-50 levy-detail-table"
                        with-items
                        :settings="false"
                        :items="row.Levies"
                        :buttons="buttons"
                        :fields="fields"
                        button-alignment="justify-content-start"></v-table>
        </b-collapse>
    </div>
</template>

<script>
import { BCollapse } from 'bootstrap-vue'
import { tooltip } from 'leaflet'
export default {
    components:{
        BCollapse
    },
    props:{
        row:Object,
        field:Object
    },
    data(){
        return {
            show:false,
            fields:[
                {name:"Dosya Numarası",key:"FileNumber",thClass:'w-17',tdClass:'text-nowrap'},
                {name:"Tebliğ Tarihi",key:"CommuniquedDateStr",thClass:'w-18',tdClass:'text-nowrap'},
                {name:"SN",key:"OrderNumber",tooltip:'Sıra numarasını ifade eder.',thClass:'w-17',tdClass:'text-nowrap'},
                {name:"Ödenen Borç (TL)",key:"CurrentPaidDebtString",thClass:'w-16',tdClass:'text-nowrap'},
                {name:"Kalan Borç (TL)",key:"CurrentRemainingDebtString",thClass:'w-16',tdClass:'text-nowrap'},
                {name:"Toplam Borç (TL)",key:"TotalDebtAmountString",thClass:'w-16',tdClass:'text-nowrap'},
                {name:"SBT",key:"FixedDeduction",tooltip:'Nafaka gibi sabit kesinti olup olmadığını ifade eder.',tdClass:'text-nowrap'},
                {name:"DD",key:"PayeeGovernment",tooltip:'Devlet dairesi önceliğini ifade eder.',tdClass:'text-nowrap'},
                {name:"AKTF",key:"Active",tooltip:'Sabit kesintinin ödemeye devam edilip edilmediğini ifade eder.',tdClass:'text-nowrap'},
                {name:"DRM",key:"Accepted",tooltip:'İcranın kabul edilip edilmediğini ifade eder.',tdClass:'text-nowrap'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"Dosyalar",key:"files",icon:"FolderIcon",variant:"primary",action:this.files},
                { text:"Ödemeler",key:"payments",icon:"ListIcon",variant:"info",action:this.payments},
                { text:"Deaktif Et",key:"logs",icon:"XCircleIcon",variant:"danger",action:this.toggleActive,condition:(i) => i.Active},
                { text:"Aktif Et",key:"logs",icon:"CheckCircleIcon",variant:"warning",action:this.toggleActive,condition:(i) => !i.Active},
                { text:"Güncelleme Geçmişi",key:"logs",icon:"ClockIcon",variant:"warning",action:this.logs,condition:(i) => (i.ChangeLogs || []).length > 0},
                //{ text:"İcra Belgesi",key:"levy-document",icon:"DownloadIcon",variant:"success",action:this.download },
                { text:"Bitir",key:"deactivate",icon:"XSquareIcon",variant:"danger",action:this.deactivate, condition:(item)=>item.FixedDeduction && item.Active },
                //{ text:"Reddet",key:"deactivate",icon:"CornerUpRightIcon",variant:"danger",action:this.reject, condition:(item)=>item.Accepted},
                // { text:"Taksitler",key:"installment",icon:"CalendarIcon",variant:"primary",action:this.installment },
                //{ text:"Öde",key:"pay",icon:"CheckCircleIcon",variant:"info",action:this.pay, condition:(item)=>item.CurrentRemainingDebt > 0},
                //{ text:"TMS Kasadan Öde",key:"pay-tms-vault",icon:"CheckCircleIcon",variant:"warning",action:this.payTMSVault, condition:(item)=>item.CurrentRemainingDebt > 0},
            ]
        }
    },
    methods:{
        edit(item){
            this.$emit('action','edit',item)
        },
        delete(item){
            this.$emit('action','delete',item)
        },
        download(item){
            this.$emit('action','download',item)
        },
        pay(item){
            this.$emit('action','pay',item)
        },
        payTMSVault(item){
            this.$emit('action','payTMSVault',item)
        },
        deactivate(item){
            this.$emit('action','deactivate',item,this.$refs.table)
        },
        reject(item){
            this.$emit('action','reject',item,this.$refs.table,this.row)
        },
        files(item){
            this.$emit('action','files',item,this.row)
        },
        payments(item){
            this.$emit('action','payments',item, this.row)
        },
        logs(item){
            this.$emit('action','logs',item, this.row)
        },
        toggleActive(item){
            this.$emit('action','toggleactive',item,this.$refs.table)
        },
        uploadExcel(){
            this.$emit('action','uploadexcel',this.row)
        }
    }
}
</script>

<style>
.chevron{
    font-size: 2rem;
}
</style>
